<template>
  <div class="background">
    <div class="complaint">
      <div class="complaint__image">
        <div class="complaint__text">
          <div class="bigTitle">민원신청</div>
          <div class="bigContent">
            불편사항을 접수해 주시면 신속히 처리하겠습니다.
          </div>
        </div>
      </div>
    </div>
    <div class="guide__wrap">
      <div class="guide__title">
        <div class="content1">민원처리안내</div>
        <div class="content2"></div>
        <div class="content3">민원신청</div>
      </div>
      <div class="content_box">
        <div
          class="content_wrap"
          v-for="(item, index) in complaint_guides"
          :key="item.index"
          :style="{ 'background-color': item.color }"
        >
          <div class="guide">
            <div class="number_title">
              {{ index + 1 }}
              {{ item.title }}
            </div>
            <div
              class="content"
              v-for="item in item.content"
              :key="item.index"
              v-html="item"
            ></div>
          </div>
        </div>
      </div>
      <div class="customerService">
        <div class="customerService-content1">
          상담 및 이용안내 등의 CS문의는&nbsp;
        </div>
        <div class="content2-wrap">
          <div class="customerService-content2">
            <span class="customerService-content2 span"
              >홈페이지 우측 하단</span
            >
            <!-- </div> -->
            <img
              class="customerService-content2-img"
              src="~@/assets/img/complaint/kakao_ic.svg"
            />
            <!-- <div class="customerService-content3"> -->
            을 이용하시기 바랍니다.
          </div>
        </div>
      </div>
    </div>
    <div class="grey">
      <div class="processTitle">민원처리 절차</div>
      <div
        class="wrap"
        v-for="(item, index) in complaint_processes"
        :key="item.title"
      >
        <div class="processContent">
          <div class="img">
            <img class="img_src" :src="item.img" />
          </div>
          <div class="contents">
            <div class="contents__title" v-html="item.title"></div>
            <div
              class="contents__content"
              v-for="item in item.content"
              :key="item.index"
              v-html="item"
            ></div>
          </div>
          <div class="arrow" v-if="index < complaint_processes.length - 1">
            <img class="arrow_img" src="~@/assets/img/complaint/arrow_ic.svg" />
          </div>
        </div>
      </div>
    </div>
    <div class="dark-grey opacity">
      <div class="info">
        <img
          class="info-img"
          src="~@/assets/img/complaint/info_ic.svg"
        />문의처: 사업운영부
      </div>
      <div class="email">
        <img
          class="email-img"
          src="~@/assets/img/complaint/email_ic.svg"
        />이메일: help@flybit.com
      </div>
    </div>
    <div class="boxWrap opacity2">
      <div class="downWrap">
        <a
          href="https://drive.google.com/file/d/1nnDLC7cN7r2fsv-AtswXDcVAxWh7KyRf/view?usp=sharing"
          ><div class="box left">
            <img
              src="~@/assets/img/complaint/download.svg"
              class="download_img"
            />
            <div class="download_content margin">민원신청서 다운로드</div>
          </div></a
        >
        <a
          href="https://drive.google.com/file/d/1KTdNh8yL3MTItukt1AJP6QP6O_cMSo0-/view?usp=sharing"
          ><div class="box">
            <img
              src="~@/assets/img/complaint/download.svg"
              class="download_img"
            />
            <div class="download_content">민원규정서 다운로드</div>
          </div></a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      complaint_guides: [
        {
          title: "민원정의",
          color: "#8289e2",
          num_color: "#8e95e5",
          content: [
            "투자자 및 이해관계인이 제기하는 이의신청, 진정, 건의, 질의 및 기타 특정한 행위를 요구하는 것.",
          ],
        },
        {
          title: "이용자 정보보호",
          color: "#78aaf0",
          num_color: "#85b2f1",
          content: [
            "<b>금융민원</b>: 회사의 금융민원과 관련하여 투자자 및 이해관계인으로부터 제기되는 이의신청, 진정사항 또는 요청에 관한 사무.",
            "<b>기타민원</b>: 회사업무와 관련하여 단순한 질의, 건의 및 기타 회사에 특정한 행위를 요구하는 것 중 금융민원에 해당되지 않는 사무.",
          ],
        },
        {
          title: "민원으로 보지 않는 경우",
          color: "#6ed29b",
          num_color: "#7dd7a5",
          content: [
            "회사와 사법상의 계약을 체결하거나 또는 계약관계에 있는 투자자 및 이해관계인이 사법적인 효과를 얻기 위하여 특정한 행위를 요구하는 경우.",
            "법원판결에 의하여 확정된 사항, 재판에 계류중인 사항, 금융감독원 등이 처리중인 사항 및 수사기관에서 수사중인 사항에 대하여 특정한 행위를 요구하는 경우.",
            "성명 및 주소 등이 분명하지 않거나 대리인 입증이 불명하거나 주장내용이 분명하지 않은 민원.",
          ],
        },
      ],

      complaint_processes: [
        {
          title: "민원의 접수",
          content: [
            "문서, 모사전송, 인터넷 등 입증이 가능한 방법에 의해 접수 다만 민원인의 의사표시를 문서로 증명할 필요가 없는 민원의 경우 직접 구술 또는 채팅으로 접수 가능.",
          ],
          img: require("../../assets/img/complaint/register.svg"),
        },
        {
          title: "민원 접수 사실 통지",
          content: [
            "민원담당자는 민원서류를 접수 즉시 민원접수 사실, 민원처리 담당자 성명 및 이메일 주소 등을 민원인에게 문서, 모사 전송, 전자우편, 문자메시지, 녹취 전화 등 입증이 가능한 방법으로 통지하여야 함.",
          ],
          img: require("../../assets/img/complaint/notification.svg"),
        },
        {
          title: "민원서류의 보완",
          content: [
            "민원서류에 중대한 흠결이 있거나, 민원신청 첨부서류가 누락된 경우 상당기간을 정하여 민원인에게 보완을 요구할 수 있음. ",
            "보완은 문서, 모사전송, 전자우편 또는 녹취 전화 등 입증이 가능한 방법으로 요구 보완기간은 7일을 원칙으로 함, 다만 민원인이 보완기간의 변경을 요청하는 경우 이를 고려하여 보완기간을 정함.",
          ],
          img: require("../../assets/img/complaint/supplement.svg"),
        },
        {
          title: "민원의 철회",
          content: [
            "민원인은 당해 민원사무의 처리가 종결되기 전에 그 신청 내용을 변경할 수 있으며, 철회 또는 취하할 수 있음.",
            "민원의 철회 또는 취하는 민원인이 문서, 모사전송, 인터넷 또는 녹취 전화 등 입증이 가능한 방법으로 함.",
          ],
          img: require("../../assets/img/complaint/widthdrawl.svg"),
        },
        {
          title: "민원처리기간",
          content: [
            "민원접수일로부터 14일 이내에 처리 다만 외부기관에서 이첩, 이송된 민원으로",
            " 처리기간이 명시된 민원은 예외. 민원처리기간에 삽입되지 않는 기간 조사 등 부득이한 사유로 처리기간 내에 처리가 곤란하다고 인정되는 경우에는 14일의 범위 내에서 1회에 한하여 그 기간을 연장할 수 있음.",
          ],
          img: require("../../assets/img/complaint/duration.svg"),
        },
        {
          title: "처리결과 통지",
          content: [
            "민원처리를 종결한 경우 그 결과를 지체 없이 민원인에게 통지 하고 통지사항에는 민원의 처리결과, 처리근거, 이의신청안내 등을 포함.",
            " 민원처리결과는 다른 법령 등에 특별한 규정이 있는 경우를 제외하고는 문서 또는 인터넷(전자민원 창구 접수 민원인 경우), 녹취 전화 등으로 통지함.",
          ],
          img: require("../../assets/img/complaint/result.svg"),
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.background {
  .complaint {
    margin: 0 auto;
    .complaint__image {
      background: url("~@/assets/img/complaint/KV_img.png");
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      width: 100%;
      height: 152px;
      padding: 0 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      .complaint__text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .bigTitle {
          margin-bottom: 28px;
          font-size: 24px;
          font-weight: bold;
          text-align: center;
          color: #fff;
        }
        .bigContent {
          width: 100%;
          font-size: 14px;
          font-weight: 300;
          color: #fff;
          text-align: center;
        }
      }
    }
  }
  .guide__wrap {
    align-items: center;
    justify-content: center;
    text-align: center;
    margin: 0 auto;
    .guide__title {
      margin: 20px auto;
      display: flex;
      justify-content: center;
      .content1 {
        font-size: 16px;
        font-weight: 500;
        color: #050528;
      }
      .content2 {
        width: 2px;
        height: 23px;
        background-color: #e5e5e5;
        margin-right: 12px;
        margin-left: 12px;
      }
      .content3 {
        font-size: 16px;
        font-weight: 500;
        color: #050528;
      }
    }
    .content_box {
      display: flex;
      flex-direction: column;
      align-items: center;
      .content_wrap {
        margin-bottom: 20px;
        border-radius: 8px;
        width: 91.1%;
        padding: 12px 14px 24px;
        .guide {
          text-align: center;
          align-items: center;
          display: block;
          text-align: left;
          .number_title {
            font-size: 16px;
            font-weight: 500;
            color: #fff;
            margin-bottom: 12px;
          }
          .content {
            font-size: 13px;
            font-weight: 300;
            text-align: left;
            color: #fff;
            word-break: keep-all;
            margin-bottom: 12px;
          }
        }
      }
    }
    .customerService {
      padding: 13px 10px;
      margin: 0 auto;
      display: block;
      width: 91.1%;
      border-radius: 8px;
      border: solid 1px #ffe100;
      background-color: #fffadc;
      justify-content: center;
      align-items: center;
      margin-bottom: 31px;
      .customerService-content1 {
        font-size: 13px;
        font-weight: 300;
        color: #333;
        margin-bottom: 4px;
      }
      .content2-wrap {
        display: flex;
        justify-content: center;
        word-break: keep-all;
        .customerService-content2 {
          font-size: 13px;
          font-weight: 300;
          color: #333;
          &.span {
            font-size: 13px;
            font-weight: 500;
            color: #333;
          }
        }
        .customerService-content2-img {
          width: 24px;
          height: 24px;
          margin-right: 4px;
          margin-left: 4px;
        }
      }
    }
  }

  .grey {
    background-color: #f9fafc;
    padding-top: 44px;
    padding-bottom: 80px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .processTitle {
      font-size: 16px;
      font-weight: 500;
      color: #050528;
      text-align: center;
      margin-bottom: 20px;
    }
    .wrap {
      padding-right: 16px;
      padding-left: 16px;
      display: block;
      width: 100%;
      box-sizing: border-box;
      .processContent {
        display: flex;
        flex-direction: column;
        margin: 0 auto;
        justify-content: center;
        align-items: center;
        text-align: center;
        .img {
          width: 60px;
          height: 60px;
          margin-bottom: 12px;
        }
        .contents {
          &__title {
            font-size: 16px;
            font-weight: 500;
            color: #333;
            margin-bottom: 11px;
          }
          &__content {
            margin-bottom: 12px;
            font-size: 13px;
            font-weight: 300;
            color: #333;
            text-align: center;
            word-break: keep-all;
          }
        }
      }
      .arrow {
        width: 15px;
        height: 8px;
        margin-bottom: 44px;
        margin-top: 44px;
      }
    }
  }
  .dark-grey {
    background-color: rgb(195, 200, 215, 0.4);
    width: 100%;
    padding: 25px 17px;
    justify-content: center;
    align-items: center;
    display: block;
    border-top: 1px solid #d9dce6;
    border-bottom: 1px solid #d9dce6;
    align-items: stretch;

    .info {
      .info-img {
        width: 28px;
        height: 28px;
        margin-right: 10px;
      }
      color: #000;
      margin-right: 48px;
      font-size: 18px;
      font-weight: 300;
      margin-bottom: 26px;
    }

    .email {
      .email-img {
        width: 28px;
        height: 28px;
        margin-right: 10px;
      }
      color: #000;
      font-size: 18px;
      font-weight: 300;
    }
  }
  .boxWrap {
    background-color: rgb(195, 200, 215, 0.2);
    display: flex;
    flex-direction: column;
    padding-top: 44px;
    padding-bottom: 44px;
    width: 100%;
    padding-right: 16px;
    padding-left: 16px;
    .downWrap {
      box-sizing: border-box;
      @media (max-width: 320px) {
        .box {
          padding: 8.88% 15.2%;
          display: flex;
          border-radius: 8px;
          border: solid 1px #000;
          background-color: #fff;
          justify-content: center;
          align-items: center;
          &.left {
            margin-bottom: 24px;
          }
          .download_img {
            width: 28px;
            height: 28px;
            margin-right: 20px;
          }
          .download_content {
            font-size: 20px;
            font-weight: 500;
            color: #000;
            word-break: keep-all;
          }
        }
      }
      @media (min-width: 321px) {
        .box {
          display: flex;
          width: 100%;
          height: 92px;
          border-radius: 8px;
          border: solid 1px #000;
          background-color: #fff;
          justify-content: center;
          align-items: center;
          &.left {
            margin-bottom: 24px;
          }
          .download_img {
            width: 28px;
            height: 28px;
            margin-right: 20px;
          }
          .download_content {
            font-size: 20px;
            font-weight: 500;
            color: #000;
          }
        }
      }
    }
  }
}
</style>
